export const scrollToFirstError = (options = {}) => {
  const { offset = -200, containerSelector } = options;

  // find the first container marked as a field with error
  const firstErrorEl = document.querySelector('.field-error');
  if (!firstErrorEl) return;

  // if a specific scrollable container is provided, scroll that; otherwise, window
  const container = containerSelector ? document.querySelector(containerSelector) : window;

  const scrollTo = (top) => {
    if (container === window) {
      window.scrollTo({ top, left: 0, behavior: 'smooth' });
    } else if (container && typeof container.scrollTo === 'function') {
      container.scrollTo({ top, left: 0, behavior: 'smooth' });
    }
  };

  const rect = firstErrorEl.getBoundingClientRect();
  const currentScrollTop = container === window ? window.scrollY : container.scrollTop;
  const top = rect.top + currentScrollTop + offset;

  scrollTo(top);

  // try to focus a focusable control inside the error container after scrolling
  const focusable = firstErrorEl.querySelector(
    'input, select, textarea, button, [tabindex]:not([tabindex="-1"]), .select-field__control',
  );
  if (focusable && typeof focusable.focus === 'function') {
    // slight timeout to ensure scroll starts
    setTimeout(() => focusable.focus({ preventScroll: true }), 150);
  }
};
